export default __webpack_public_path__ + "static/MakerDAO-34bd346cd4f1edeea7b5a628b67762ab.png";